import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
// import { getMiscellaneousData, getQuestion } from "../../util/SheetManager";
import { firebaseConstants, getDb, levelNames } from "../../util/Constants";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  where,
  query,
  updateDoc,
} from "firebase/firestore";
import { getQuestion } from "util/SheetManager";

export default function EditQuestion(props) {
  const [data, setData] = useState(null);
  const [type, setType] = useState("Email");
  const [leadershipAbility, setLeadershipAbility] = useState("");
  const [optionRewards, setOptionRewards] = useState({});
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState([
    {
      option: "",
      animation: "sad",
      reward: "",
      response: "1",
    },
  ]);
  const [difficulty, setDifficulty] = useState("");
  const [loading, setLoading] = useState("data");
  const [questionId, setQuestionId] = useState("");
  const { ID, count, eventId, lName } = useParams();
  const history = useHistory();

  const db = getDb();
  const utilRef = collection(db, firebaseConstants.dbUtil);

  useEffect(async () => {
    let obj = {};
    const parentDocumentRef = doc(getDb(), "Events", eventId);
    const subcollectionRef = doc(parentDocumentRef, lName, ID);

    getDoc(subcollectionRef)
      .then((querySnapshot) => {
        if (querySnapshot.exists()) {
          console.log("Document data:", querySnapshot.data());
          obj= querySnapshot.data()
          setQuestionId(ID)
        } else {
          console.log("No such document!");
        }

        // setQuestionsData(dataArr)
        if (obj) {
          const responses = obj["response"].split("|");
          const rewards = obj["reward"].split("|");
          const options = [
            {
              option: obj["answerOne"],
              animation: obj["responseOne"],
              reward: rewards.length >= 0 ? rewards[0] : 0,
              response: responses[0],
            },
          ];

          if (obj["answerTwo"]) {
            options.push({
              option: obj["answerTwo"],
              animation: obj["responseTwo"],
              reward: rewards.length >= 2 ? rewards[1] : 0,
              response: responses.length >= 2 ? responses[1] : "1",
            });
          }
          if (obj["answerThree"]) {
            options.push({
              option: obj["answerThree"],
              animation: obj["responseThree"],
              reward: rewards.length >= 3 ? rewards[2] : 0,
              response: responses.length >= 3 ? responses[2] : "1",
            });
          }
          if (obj["answerFour"]) {
            options.push({
              option: obj["answerFour"],
              animation: obj["responseFour"],
              reward: rewards.length >= 4 ? rewards[3] : 0,
              response: responses.length >= 4 ? responses[3] : "1",
            });
          }

          setType(obj["type"]);
          setLeadershipAbility(obj["ability"]);
          setName(obj["name"]);
          setSubject(obj["subject"]);
          setEmail(obj["email"]);
          setQuestion(obj["question"]);
          setDifficulty(obj["difficulty"]);
          setOptions(options);
          setData(obj);
          setLoading(null);
        }
      })
      .catch((error) => {
        // setQuestionsData(null)
        console.log(error);
      });
  }, []);

  useEffect(() => {
    let questionLimit = 0,
      optionLimit = 0;
    if (type === "Question") {
      questionLimit = 100;
      optionLimit = 60;
    } else if (type === "SMS") {
      questionLimit = 200;
      optionLimit = 40;
    } else if (type === "Email") {
      questionLimit = 300;
      optionLimit = 30;
    }

    setQuestion(question.slice(0, questionLimit));
    setOptions(
      options.map((_option) => ({
        ..._option,
        option: _option.option.slice(0, optionLimit),
      }))
    );
  }, [type]);

  const getMetaData = async () => {
    let data = {};
    const docRef = doc(utilRef, "meta");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      data = docSnap.data();
    }

    return data;
  };

  const addOption = () => {
    setOptions([
      ...options,
      {
        option: "",
        animation: "sad",
        reward: "",
        response: "1",
      },
    ]);
  };

  const deleteOption = (index) => {
    setOptions(options.filter((ans, i) => index !== i));
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const rowsInput = [...options];
    rowsInput[index][name] = value;

    if (name === "response") {
      rowsInput[index]["reward"] =
        value === "1"
          ? optionRewards.best
          : value === "2"
          ? optionRewards.ok
          : optionRewards.wrong; // 1 is best, 2 is ok, 3 is wrong
    }

    setOptions(rowsInput);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading("saving");
    console.log(questionId);
    try {
      const documentRef = doc(getDb(), "Events", eventId, lName, questionId);
      await updateDoc(documentRef, {
        type: type,
        ability: leadershipAbility,
        difficulty: difficulty,
        question: question,
        subject: type === "Email" ? subject : "",
        name: type !== "Question" ? name : "",
        email: type === "Email" ? email : "",
        answerOne: options[0].option,
        responseOne:
          type === "Question" && options[0] ? options[0].animation : "",
        answerTwo: options[1] ? options[1].option : "",
        responseTwo:
          type === "Question" && options[1] ? options[1].animation : "",
        answerThree: options[2] ? options[2].option : "",
        responseThree:
          type === "Question" && options[2] ? options[2].animation : "",
        answerFour: options[3] ? options[3].option : "",
        responseFour:
          type === "Question" && options[3] ? options[3].animation : "",
        response: options.map((_ans) => _ans.response).join("|"),
        reward: "",
      });
    } catch (e) {
      console.log(e);
    }

    history.push(`/admin/levelDetails/${eventId}/${lName}`);
  };

  return (
    <>
      <Container fluid>
        <Row className="mb-4">
          <Col>
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h2 className="mb-0">Edit Question</h2>
              </CardHeader>
              <CardBody>
                {loading === "data" ? (
                  <div className="text-center py-5 mt-5">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-2">
                      {/* <Col lg={4}> */}
                      {/* <Row>
                                                        <Col sm={12}>
                                                            <FormGroup>
                                                                <Label for="type">Type</Label>
                                                                <Input
                                                                    type="select"
                                                                    name="type"
                                                                    id="type"
                                                                    value={type}
                                                                    className="form-control-alternative"
                                                                    required
                                                                    onChange={(e) => {
                                                                        setType(e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="Question">Question</option>
                                                                    <option value="Email">Email</option>
                                                                    <option value="SMS">SMS</option>
                                                                </Input>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <FormGroup>
                                                                <Label for="leadershipAbility">
                                                                    Leadership Ability
                                                                </Label>
                                                                <Input
                                                                    type="select"
                                                                    required
                                                                    id="leadershipAbility"
                                                                    value={leadershipAbility}
                                                                    className="form-control-alternative"
                                                                    onChange={(e) =>
                                                                        setLeadershipAbility(e.target.value)
                                                                    }
                                                                >
                                                                    {
                                                                        abilities.map(_ability => <option
                                                                            value={_ability}>{_ability}</option>)
                                                                    }
                                                                </Input>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row> */}
                      {/* </Col> */}

                      <Col lg={8}>
                        <Row>
                          {type === "Email" && (
                            <Col lg={4}>
                              <FormGroup>
                                <Label for="Email">Email</Label>
                                <Input
                                  type="text"
                                  id="Email"
                                  required
                                  value={email}
                                  maxLength={30}
                                  onInput={(object) => {
                                    if (
                                      object.target.value.length >
                                      object.target.maxLength
                                    )
                                      object.target.value =
                                        object.target.value.slice(
                                          0,
                                          object.target.maxLength
                                        );
                                  }}
                                  className="form-control-alternative"
                                  onChange={(e) => setEmail(e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                          )}
                          {(type === "Email" || type === "SMS") && (
                            <Col lg={type === "SMS" ? "12" : "4"}>
                              <FormGroup>
                                <Label for="name">Name</Label>
                                <Input
                                  type="text"
                                  id="name"
                                  required
                                  maxLength={20}
                                  onInput={(object) => {
                                    if (
                                      object.target.value.length >
                                      object.target.maxLength
                                    )
                                      object.target.value =
                                        object.target.value.slice(
                                          0,
                                          object.target.maxLength
                                        );
                                  }}
                                  value={name}
                                  className="form-control-alternative"
                                  onChange={(e) => setName(e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                          )}
                          {type === "Email" && (
                            <Col lg={4}>
                              <FormGroup>
                                <Label for="subject">Subject</Label>
                                <Input
                                  type="text"
                                  id="subject"
                                  required
                                  maxLength={40}
                                  onInput={(object) => {
                                    if (
                                      object.target.value.length >
                                      object.target.maxLength
                                    )
                                      object.target.value =
                                        object.target.value.slice(
                                          0,
                                          object.target.maxLength
                                        );
                                  }}
                                  value={subject}
                                  className="form-control-alternative"
                                  onChange={(e) => setSubject(e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                          )}
                        </Row>
                        <FormGroup>
                          <Label for="question">Question</Label>
                          <Input
                            type="textarea"
                            id="question"
                            rows={5}
                            required
                            value={question}
                            className="form-control-alternative"
                            onChange={(e) => setQuestion(e.target.value)}
                            maxLength={
                              type === "Question"
                                ? 100
                                : type === "SMS"
                                ? 200
                                : 300
                            }
                            onInput={(object) => {
                              if (
                                object.target.value.length >
                                object.target.maxLength
                              )
                                object.target.value = object.target.value.slice(
                                  0,
                                  object.target.maxLength
                                );
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <div className="d-flex justify-content-between">
                          <h3 className="mb-0">Options</h3>
                          {options.length < 4 && (
                            <Button
                              onClick={addOption}
                              color="success"
                              type="button"
                              size="sm"
                            >
                              <i className="fas fa-plus mr-2" />
                              Option
                            </Button>
                          )}
                        </div>
                        <hr className="mt-3" />
                      </Col>
                      {options.map((data, index) => (
                        // <Col lg={12}>
                        <Col lg={6}>
                          <div className="p-3 border rounded mb-4 bg-lighter">
                            <Row>
                              <Col lg={8}>
                                <FormGroup>
                                  <div className="d-flex justify-content-between mb-2">
                                    <Label for="optionText">
                                      {` Option ${index + 1} `}
                                    </Label>
                                    {options.length > 1 && (
                                      <Button
                                        color="danger"
                                        type="button"
                                        size="sm"
                                        onClick={() => deleteOption(index)}
                                      >
                                        <i className="far fa-trash-alt" />
                                      </Button>
                                    )}
                                  </div>
                                  <Input
                                    rows={10}
                                    type="textarea"
                                    id="optionText"
                                    value={data.option}
                                    required
                                    name="option"
                                    className="form-control-alternative"
                                    onChange={(event) =>
                                      handleChange(index, event)
                                    }
                                    maxLength={
                                      type === "Question"
                                        ? 60
                                        : type === "SMS"
                                        ? 40
                                        : 30
                                    }
                                    onInput={(object) => {
                                      if (
                                        object.target.value.length >
                                        object.target.maxLength
                                      )
                                        object.target.value =
                                          object.target.value.slice(
                                            0,
                                            object.target.maxLength
                                          );
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg={4}>
                                {type === "Question" && (
                                  <FormGroup>
                                    <Label for="animation">Animation</Label>
                                    <Input
                                      type="select"
                                      name="animation"
                                      id="animation"
                                      value={data.animation}
                                      required
                                      className="form-control-alternative"
                                      onChange={(event) =>
                                        handleChange(index, event)
                                      }
                                    >
                                      <option value="sad">Sad</option>
                                      <option value="happy">Happy</option>
                                      <option value="angry">Angry</option>
                                      <option value="normal">Normal</option>
                                    </Input>
                                  </FormGroup>
                                )}

                                {/* <FormGroup>
                                                                        <Label for="reward">
                                                                            Reward
                                                                        </Label>
                                                                        <Input
                                                                            type="text"
                                                                            id="reward"
                                                                            required
                                                                            name="reward"
                                                                            readOnly
                                                                            value={data.reward}
                                                                            className="form-control-alternative"
                                                                        />
                                                                    </FormGroup> */}
                                <FormGroup>
                                  <Label for="response">Response</Label>
                                  <Input
                                    type="select"
                                    id="response"
                                    name="response"
                                    value={data.response}
                                    required
                                    className="form-control-alternative"
                                    onChange={(event) =>
                                      handleChange(index, event)
                                    }
                                  >
                                    <option value="1">Best</option>
                                    <option value="2">Ok</option>
                                    <option value="3">Wrong</option>
                                  </Input>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <Row>
                      <Col className="text-right">
                        <Button
                          color="danger"
                          onClick={() => history.goBack()}
                          disabled={loading === "saving"}
                        >
                          Cancel
                        </Button>
                        <Button
                          color="primary"
                          type="submit"
                          disabled={loading === "saving"}
                        >
                          {loading === "saving" ? (
                            <Spinner color="light" size="sm" />
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
